import { render, staticRenderFns } from "./sms-verification.vue?vue&type=template&id=91d233a6&scoped=true"
import script from "./sms-verification.vue?vue&type=script&lang=js"
export * from "./sms-verification.vue?vue&type=script&lang=js"
import style0 from "./sms-verification.vue?vue&type=style&index=0&id=91d233a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d233a6",
  null
  
)

export default component.exports